import {Box, TextInput, Text} from "@mantine/core";
import {SubjectRow} from "./SubjectRow";
import cx from "clsx";
import {IconSearch} from "@tabler/icons-react";
import commonClasses from "../../../../common/common.module.css"
import {DashboardIcons} from "../../common/constants";
import {IProtocolStats} from "../../types/IProtocolStats";
import {TSubjectId} from "../../../../common/types";


interface SubjectSessionsPanelProps {
    pStats: Array<IProtocolStats>
}


export const SubjectSessionsPanel: React.FC<SubjectSessionsPanelProps> = ({pStats}: SubjectSessionsPanelProps) => {
    const sStats = pStats.reduce((agg, stats) => {
        if (!agg[stats.subjectId])
            agg[stats.subjectId] = []
        agg[stats.subjectId].push(stats)
        return agg
    }, {} as Record<TSubjectId, Array<IProtocolStats>>)

    return (
        <Box style={{display: "grid", grid: "auto 1fr / auto"}}>
            <Box mt={"1em"} mb={"1em"} style={{display: "grid", grid: " auto / auto 1fr auto"}}>
                <Box ml="0.5em" className={cx("ntc-row-component ntc-flex-align-center")}>
                    <DashboardIcons.subjectsIcon c={"black"}/>
                    <Text ml={"0.5em"} size={"1.5em"} fw={"bold"}>Subject Session Details</Text>
                </Box>
                <Box/>
                <Box style={{alignSelf: "end"}}>
                    <TextInput placeholder={"Search subjects..."}
                               leftSection={<IconSearch size="1.5em"/>}/>
                </Box>
                <Box className={commonClasses.subtleText}>Detailed view of sessions grouped by
                    subject</Box>
            </Box>
            <Box  p={"0.25em"} style={{display: "grid", grid: "auto 1fr / auto"}}>
                {Object.keys(sStats).map((key) => (<SubjectRow key={key} sStats={sStats[key]}/>))}
            </Box>
        </Box>
    )
}
